import { jsx as _jsx } from "react/jsx-runtime";
import React, { PureComponent } from "react";
class LoadingScreen extends PureComponent {
    render() {
        if (this.props.pageErrored) {
            return _jsx("h1", { children: "Something Went Wrong" });
        }
        if (this.props.isLoading) {
            return (_jsx("div", { className: "row justify-content-center align-items-center", children: _jsx("div", { className: "col-auto", children: _jsx("i", { className: "center-block fal fa-circle-notch fa-spin fa-3x fa-fw" }) }) }));
        }
        return null;
    }
}
export default LoadingScreen;
